module.exports = "/images/Handshake.svg";